export const SUBSCRIPTION_STATUSES = [
  { id: "active", label: "Ativa", tone: "success" },
  { id: "canceled", label: "Cancelada", tone: "error" },
  { id: "pending", label: "Pendente", tone: "alert" },
  { id: "unknown", label: "Desconhecida", tone: "neutral" },
];

export const SUBSCRIPTION_STATUS_LABEL = SUBSCRIPTION_STATUSES.reduce(
  (acc, status) => ({ ...acc, [status.id]: status.label }),
  {}
);

export const SUBSCRIPTION_STATUS_TONE = SUBSCRIPTION_STATUSES.reduce(
  (acc, status) => ({ ...acc, [status.id]: status.tone }),
  {}
);
